import { Box, createStyles, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PLAIN_ICON, DARK_ICON } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: '30px 30px 10px 30px',
      // border: '1px solid #2d343e',
      border: '1px solid',
      borderColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
      borderRadius: 8,
      background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
      maxWidth: 500,
      minWidth: 500,
      maxHeight: 'fit-content',
      '& .MuiInputBase-formControl': {
        height: '50px !important',
        fontSize: '14px !important',
        overflow: 'unset !important',
      },
    },
    wrapper: {
      display: 'flex',
      padding: '20px',
      overflow: 'auto',
      overflowX: 'hidden',
      gap: 20,
      [theme.breakpoints.down(1200)]: {
        padding: '20px 10px',
        flexDirection: 'column',
      },
    },

    heading: {
      position: 'relative',
      // borderBottom: '1px solid #2d343e',
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.type === 'dark' ? COLORS.DARK_BORDER : COLORS.LIGHT_BORDER,
      alignItems: 'center',
      paddingBottom: 20,
      marginBottom: 20,

      '&::before': {
        content: '""',
        background: '#3e8bff',
        height: '1px',
        position: 'absolute',
        width: 42,
        bottom: '-1px',
      },
    },

    buttonCls: {
      height: '44px !important',
      borderRadius: 8,
      textTransform: 'unset',
      fontSize: 14,
      marginTop: 'auto',
      marginBottom: 20,
      [theme.breakpoints.down(600)]: {
        marginTop: 20,
      },
    },

    companyBox: {
      maxWidth: 320,
      height: 261,
      width: '100%',
      background: '#18212e',
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',

      '& .MuiSvgIcon-root': {
        fontSize: 60,
        marginBottom: 20,
      },
    },
    grey: {
      color: '#93a1b6',
    },
    select: {
      '& .MuiSelect-icon': {
        color: theme.palette.type === 'dark' ? PLAIN_ICON : DARK_ICON, // Change this to your desired color
      },
    },
    outlined: {},
  }),
);

export const Column = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: 20,
  gridTemplateColumns: 'repeat(1, 1fr)',
  width: '100%',
}));

// New Styled Components
export const TextSwitchColor = styled(Typography)(({ theme, size, weight }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
  fontWeight: weight || undefined,
}));

export const TextGreyColor = styled(Typography)(({ theme, size, weight }: any) => ({
  fontSize: size || 16,
  color: '#98a1ac',
  fontWeight: weight || undefined,
}));
